































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { apiQueryBuilder, objectIsEmpty } from '~/utils/common.js';
import { replaceUrl } from '~/utils/explorer.js';

import LocalisationRoutes from '~/components/lists/LocalisationRoutes.vue';
import LocalisationEvents from '~/components/lists/LocalisationEvents.vue';
import LocalisationProviders from '~/components/lists/LocalisationProviders.vue';
import LocalisationArticles from '~/components/lists/LocalisationArticles.vue';

@Component({
  layout: 'destination-map',
  computed: {
    ...mapState('explorer', [
      'destinationTab',
      'displayLocalisationMap',
      'destination',
      'destinationEvents',
      'destinationProviders',
      'destinationRoutes',
      'destinationRoutesFilters',
      'destinationEventsFilters',
      'destinationProvidersFilters',
      'hasChangedLanguage',
      'routesMap',
      'eventsMap',
      'destinationProvidersMap',
      'sports',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  middleware: ['noauth'],
  components: {
    DestinationMap: () => {
      if (process.client) {
        return import('~/components/maps/DestinationMap.vue');
      }
    },
    LocalisationRoutes,
    LocalisationEvents,
    LocalisationProviders,
    LocalisationArticles,
  },
  head () {
    const self: any = this;
    const description = self.destination?.description?.trim().replace(/<\/?[^>]+(>|$)/g, "");
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.destination.title} Map - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.destination.title} Map - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: self.destination.header_pictures?.length ? self.$thumbnailUrl(self.destination.header_pictures[0], 1200) : 'https://www.onpiste.com/img/placeholders/destination-placeholder.png',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer/destinations/${self.$slugify(self.destination.title)}-${self.destination.id}`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    self.prefillQueries();
    await self.callAllResults({ reset_append: true });
  },
  async asyncData ({ store, route, error, app }) {
    const errorInstance: any = error;

    if (
      route.params.destinationid.split('-').pop() === '' ||
      isNaN(Number(route.params.destinationid.split('-').pop()?.trim()))
    ) {
      return errorInstance({
        statusCode: 404,
        response: { data: { detail: 'Unknown Destination' } },
      });
    }

    try {
      await store.dispatch('explorer/getDestination', { id: route.params.destinationid.split('-').pop()?.trim(), lang: store.state.lang.locale });
    } catch (e) {
      return errorInstance({
        statusCode: e.response.status,
        response: { data: { detail: app.i18n.t(e.response.data.detail) } },
      });
    }

    if (!store.state.explorer.labels.length) {
      store.dispatch('explorer/getLabels', { lang: store.state.lang.locale });
    }
    if (!store.state.explorer.sports.length) {
      await store.dispatch('explorer/getSports', { lang: store.state.lang.locale });
    }

    switch (route.query?.tab) {
      case 'routes': return store.commit('explorer/SET_DESTINATION_TAB', 'routes');
      case 'events': return store.commit('explorer/SET_DESTINATION_TAB', 'events');
      case 'providers': return store.commit('explorer/SET_DESTINATION_TAB', 'providers');
    }
  },
})
export default class Explorer extends Vue {
  destination: Types.DestinationItem;
  destinationRoutes: Types.RouteList;
  destinationEvents: Types.EventList;
  destinationProviders: Types.ProviderList;
  locale: string;
  destinationRoutesFilters: {[key: string]: any};
  destinationEventsFilters: {[key: string]: any};
  destinationProvidersFilters: {[key: string]: any};
  hasChangedLanguage: boolean;
  routesMap: any;
  eventsMap: Types.EventMap;
  destinationProvidersMap: Types.ProviderMap[];

  destinationTab: string;
  displayLocalisationMap: boolean;
  cityFiltered: string = '';

  hoveredDestination: Types.DestinationItem | null = null;
  hoveredEvent: Types.Event | null = null;
  hoveredRoute: Types.Route | null = null;
  hoveredProvider: Types.Provider | null = null;

  routeOffset: number = 0;
  eventOffset: number = 0;
  providerOffset: number = 0;

  sports: Types.SportItem[];

  mobileHidder: boolean = false;

  defaultEuropeBounds: Array<number[]> = [
    [36.13901207750932, -7.635498046875001],
    [58.53619011845253, 24.005126953125004],
  ];

  distanceRange: any = [];
  elevationRange: any = [];

  routeDifficulties: number[] = [];
  routeOpened: boolean = false;
  routeTypes: Number[] | string[] = [];
  routeLabels: string[] = [];
  routeSports: string[] = [];
  routeElevationMin: number | null = null;
  routeElevationMax: number | null = null;
  routeDistanceMin: number | null = null;
  routeDistanceMax: number | null = null;

  eventTypes: any[] = [];
  eventLabels: Number[] = [];
  eventSince: string = '';
  eventUntil: string = '';
  eventSports : string[] = [];

  providerRespect: boolean = false;
  providerTypes: string[] = [];

  /*
    Depending of this.cityFiltered string, we will filter this.routesMap to
    display them on DestinationMap. If no city is filtered, we display all
    this.routesMap
  */
  get routesMapToShow () {
    if (this.cityFiltered) {
      return this.routesMap?.filter((r: any) => r.properties.city === this.cityFiltered) || [];
    }
    return this.routesMap || [];
  }

  get sportToShow () {
    const sportsToShow = [...this.destination.sports.map(sport => sport.id)];

    // if we want to add a dynamic sports-based on current map's routes
    // const arraySports: any[] = [];
    // this.routesMap.forEach((route: { properties: { sport_id: any; }; }) => {
    //   !arraySports.includes(route.properties.sport_id) && arraySports.push(route.properties.sport_id);
    // });
    // const sportsToShow = arraySports;

    const sportsToSend: any[] = [];
    const allSports: Types.SportItem[] = [];
    // for each id in sportsToShow, find the corresponding sport
    sportsToShow.forEach((id : any) => {
      const indexOfSport = this.sports.findIndex(obj => obj.id === id);
      // if sport have a parent_id
      if (this.sports[indexOfSport].parent_id) {
        // if parent_id wasn't already in array, push it
        const parentIndex = this.sports.findIndex(obj => obj.id === this.sports[indexOfSport].parent_id);
        const sportParent = this.sports[parentIndex];
        if (allSports.every(sport => sport.id !== this.sports[indexOfSport].parent_id)) {
          allSports.push({
            'id': sportParent.id,
            'title': sportParent.title,
            'icon_name': sportParent.icon_name,
            'children':[],
            'universe': sportParent.universe,
          });
        }
        const parentIndexOfAllSports = allSports.findIndex(obj => obj.id === sportParent.id);
        const sportCopy = { ...this.sports[indexOfSport] };
        allSports[parentIndexOfAllSports].children?.push(sportCopy);
      } else {
        const sportCopy = { ...this.sports[indexOfSport], children:[] };
        allSports.every(sport => sport.id !== this.sports[indexOfSport].id) && allSports.push(sportCopy);
      }
    });
    allSports.forEach((sport) => {
      if (sportsToSend.every(element => element.title !== sport.universe)) {
        sportsToSend.push({ 'title': sport.universe, 'sports': [sport] });
      } else {
        const universeIndex = sportsToSend.findIndex(obj => obj.title === sport.universe);
        sportsToSend[universeIndex].sports?.push(sport);
      }
    });
    const customSort = (a: { title: string; }, b: { title: string; }) => {
      const order = ['FOOT', 'BIKE', 'WINTER'];
      return order.indexOf(a.title) - order.indexOf(b.title);
    };
    // sort array with custom sort
    return sportsToSend.sort(customSort);
  }

  /*
    Will get every cities in this.routesMap elements to put them in the
    RouteCitiesDropdown.
  */
  get prefilledCities () {
    const items = this.routesMap;
    // Removes duplicates
    const cities = [...new Set(items?.map((r: any) => r.properties?.city))].sort();
    return cities.filter(c => c !== null);
  }

  /*
    This computed will remove potential duplicates in array. It can happen when
    user clicks a marker on map that can be append to this.destinationRoutes.
    This filter will ensure no duplicates are added to store values.
  */
  get routesToShow () {
    return this.destinationRoutes?.items?.filter((v: Types.Route, i: number, a: any) => a.findIndex((t: Types.Route) => (t.id === v.id)) === i);
  }

  /* ⬆️ */
  get eventsToShow () {
    return this.destinationEvents.items?.filter((v: Types.Event, i: number, a: any) => a.findIndex((t: Types.Event) => (t.id === v.id)) === i) || [];
  }

  /* ⬆️ */
  get providersToShow () {
    return this.destinationProviders.items?.filter((v: Types.Event, i: number, a: any) => a.findIndex((t: Types.Event) => (t.id === v.id)) === i) || [];
  }

  /*
    Calling all results is a method called when entering the page.
    This method will fetch routes/events/providers cards on the left
    side of the view (not the map elements). If it contains a
    val.reset_append argument, it means that when fetching datas, the
    offset sent will be at 0, so the datas fetched are reset from scratch.
    It prevents user to fetch too ahead datas than where he actually is when
    scrolling through cards.
  */
  async callAllResults (val: any) {
    await this.searchRoutes({ reset_append: val.reset_append });
    await this.searchEvents({ reset_append: val.reset_append });
    await this.searchProviders({ reset_append: val.reset_append });
  }

  /*
    As user can change locale on this view, some edge-cases can happen:
    - View reloads badly. The contents, not in the new language
    - The map won't be reloaded normally
    This workaround based on a store value will be useful to force update the
    view in other methods
  */
  @Watch('locale')
  handleResetOnLocale () {
    this.$store.commit('explorer/SET_HAS_CHANGED_LANGUAGE', true);
  }

  /*
    When changing tab in view, we want the filters that were applied previously
    to be applied one more time. As the filters are stored in one different state
    for each tab, this method will update URL to append queries with associated
    values.
  */
  @Watch('destinationTab')
  adaptQueryOnTab (val: string) {
    let payload: any = {};

    switch (val) {
      case 'routes': {
        payload = Object.assign(
          {},
          this.destinationRoutesFilters,
        );
        break;
      }
      case 'events': {
        payload = Object.assign(
          {},
          this.destinationEventsFilters,
        );
        break;
      }
      case 'providers': {
        payload = Object.assign(
          {},
          this.destinationProvidersFilters,
        );
        break;
      }
    }

    this.appendQueries(payload);
  }

  beforeMount () {
    if (process.client) {
      // We don't want to show the map by default on small devices
      if (window.innerWidth <= 768) {
        this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', true);
        this.mobileHidder = true;
        setTimeout(() => {
          this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', false);
          this.mobileHidder = false;
        }, 200);
      }
    }
  }

  mounted () {
    let payload = {};
    // Populating queries to create URL based on stored filters
    switch (this.destinationTab) {
      case 'routes': payload = { ...this.destinationRoutesFilters }; break;
      case 'events': payload = { ...this.destinationEventsFilters }; break;
      case 'providers': payload = { ...this.destinationProvidersFilters }; break;
    }

    window.dataLayer.push({
      'Destination': this.destination.title,
      'DestinationID': this.destination.id,
    });
    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO. It will also add queries created
      previously so when user comes back to this page later, filters will be
      applied thanks to filters handle with URL queries
    */
    replaceUrl(
      this.$route.params.destinationid,
          `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/destinations/${this.$slugify(this.destination.title)}`,
          this.$slugify(this.destination?.title),
          `/offer${apiQueryBuilder(payload)}${apiQueryBuilder(payload) ? '&' : '?'}tab=${this.destinationTab}`,
    );
  }

  beforeDestroy () {
    // Will reset every filters applied when leaving page.
    // We don't want this behavior to occur when user changes language (as
    // page is destroying then remounting when doing that)
    if (!this.hasChangedLanguage) {
      this.$store.commit('explorer/SET_ROUTES_MAP', []);
      this.$store.commit('explorer/SET_DESTINATION_TAB', 'routes');
      this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {});
      this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {});
      this.$store.commit('explorer/SET_DESTINATION_MAP_PROVIDERS_FILTERS', {});
    }
  }

  /* This method updates active history (URL) to handle filters applied by user */
  async appendQueries (payload: any) {
    if (process.client) {
      await history.replaceState(
        {},
        '',
        `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/destinations/${this.$slugify(this.destination.title)}-${this.destination.id}/offer${apiQueryBuilder(payload)}${apiQueryBuilder(payload) ? '&' : '?'}tab=${this.destinationTab}`,
      );
    }
  }

  /*
    This method will update the list of routes to display in both cards and map.
    Filters that were applied in dropdowns are handled.
  */
  async searchRoutes (payload: any) {
    if (!objectIsEmpty(this.destination)) {
      this.elevationRange = [this.routeElevationMin, this.routeElevationMax];
      this.distanceRange = [this.routeDistanceMin, this.routeDistanceMax];

      await this.$store.dispatch('explorer/getDestinationRoutes', {
        destination_id: this.destination.id,
        types: this.routeTypes,
        difficulties: this.routeDifficulties,
        sport_ids: this.routeSports,
        opened: this.routeOpened,
        lang: this.locale,
        elevation_min: this.elevationRange[0],
        elevation_max: this.elevationRange[1],
        distance_min: this.distanceRange[0],
        distance_max: this.distanceRange[1],
        offset: this.routeOffset,
        city: this.cityFiltered,
        limit: 12,
        has_more: this.destinationRoutes.has_more,
        reset_append: payload.reset_append,
        label_ids: this.routeLabels,
      });

      // When payload.prevent_map_reload is true, it means that we don't want
      // the map to be rendered with new elements. The main case for this
      // behavior is when user scrolls inside cards div, reaches bottom so triggers
      // infinite scroll fetch. On the map, all the markers of every (or filtered)
      // routes are displayed. It is redundant to fetch datas that are here
      // already, so we prevent it.
      if (!payload.prevent_map_reload) {
        await this.getRoutesMap(payload);
      }

      // Delete these useless attributes because we don't want to keep these in
      // store.
      delete payload.reset_append;
      delete payload.prevent_map_reload;

      // Update this.destinationRoutesFilters state
      this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {
        sport: this.routeSports,
        types: this.routeTypes,
        label:  this.routeLabels,
        opened: this.routeOpened,
        difficulties: this.routeDifficulties,
        elevation_min: this.routeElevationMin,
        elevation_max: this.routeElevationMax,
        distance_min: this.routeDistanceMin,
        distance_max: this.routeDistanceMax,
        routeCity: this.cityFiltered,
      });

      // Updates the history (URL) with active filters if some defined
      if (this.destinationTab === 'routes') {
        this.appendQueries({
          ...this.destinationRoutesFilters,
        });
      }
    }
  }

  /*
    This method will update routes markers displayed in map. It is called only
    when:

    - User applies a filter inside of the dropdowns

    It won't be triggered if user fetches more routes when infinite-scrolling
    down the cards div.
   */
  async getRoutesMap (payload: any) {
    await this.$store.dispatch('explorer/getRoutesMap', {
      destination_id: this.destination.id,
      types: this.routeTypes,
      difficulties: this.routeDifficulties,
      sport_ids: this.routeSports,
      label_ids: this.routeLabels,
      opened: this.routeOpened,
      lang: this.locale,
      elevation_min: this.elevationRange[0],
      elevation_max: this.elevationRange[1],
      distance_min: this.distanceRange[0],
      distance_max: this.distanceRange[1],
      offset: this.routeOffset,
      city: this.cityFiltered,
      limit: 12,
      has_more: this.destinationRoutes.has_more,
      reset_append: payload.reset_append,
    });
  }

  /* See this.searchRoutes for explanations as it follow the same logic */
  async searchEvents (payload: any) {
    if (!objectIsEmpty(this.destination)) {
      await this.$store.dispatch('explorer/getDestinationEvents', {
        destination_id: this.destination.id,
        label_ids: this.eventLabels,
        sport_ids: this.eventSports,
        lang: this.locale,
        event_type: this.eventTypes,
        since: this.eventSince,
        until: this.eventUntil,
        offset: this.eventOffset,
        limit: 12,
        has_more: this.destinationEvents.has_more,
        reset_append: payload.reset_append,
      });

      delete payload.reset_append;
      delete payload.prevent_map_reload;

      if (!payload.prevent_map_reload) {
        await this.getEventsMap(payload);
      }

      this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {
        sport: this.eventSports,
        event_type: this.eventTypes,
        label:  this.eventLabels,
        since: this.eventSince,
        until: this.eventUntil,
      });

      if (this.destinationTab === 'events') {
        this.appendQueries({
          ...this.destinationEventsFilters,
          ...{ sport: this.eventSports },
        });
      }
    }
  }

  /* See this.getRoutesMap for explanations as it follow the same logic */
  async getEventsMap (payload: any) {
    await this.$store.dispatch('explorer/getEventsMap', {
      destination_id: this.destination.id,
      label_ids: this.eventLabels,
      sport_ids: this.eventSports,
      lang: this.locale,
      event_type: this.eventTypes,
      since: this.eventSince,
      until: this.eventUntil,
    });
  }

  /* See this.searchRoutes for explanations as it follow the same logic */
  async searchProviders (payload: any) {
    if (!objectIsEmpty(this.destination)) {
      await this.$store.dispatch('explorer/getDestinationProviders', {
        destination_id: this.destination.id,
        provider_type: this.providerTypes,
        respect: this.providerRespect,
        lang: this.locale,
        offset: this.providerOffset,
        limit: 12,
        has_more: this.destinationProviders.has_more,
        reset_append: payload.reset_append,
      });

      if (!payload.prevent_map_reload) {
        await this.getProvidersMap(payload);
      }

      delete payload.reset_append;
      delete payload.prevent_map_reload;

      this.$store.commit('explorer/SET_DESTINATION_MAP_PROVIDERS_FILTERS', {
        providerTypes: this.providerTypes.map((t: string) => t),
        providerRespect: this.providerRespect,
      });

      if (this.destinationTab === 'providers') {
        this.appendQueries({
          ...this.destinationProvidersFilters,
        });
      }
    }
  }

  /* See this.getRoutesMap for explanations as it follow the same logic */
  async getProvidersMap (payload: any) {
    await this.$store.dispatch('explorer/getDestinationProvidersMap', {
      destination_id: this.destination.id,
      lang: this.locale,
      provider_type: this.providerTypes,
      respect: this.providerRespect,
    });
  }

  /*
    When user adds/removes a filter in route Tab, we update associated data of
    this page so it will be easier to prepare this.searchRoutes
  */
  populateRouteFilters (payload: any) {
    this.routeDifficulties = payload.difficulties;
    this.routeOpened = payload.opened;
    this.routeTypes = payload.types;
    this.routeLabels = payload.label;
    this.routeSports = payload.sport;
    this.routeElevationMin = payload.elevation_min;
    this.routeElevationMax = payload.elevation_max;
    this.routeDistanceMin = payload.distance_min;
    this.routeDistanceMax = payload.distance_max;
  }

  /* Same logic than this.populateRouteFilters but for events filters */
  populateEventFilters (payload: any) {
    this.eventTypes = payload.event_type;
    this.eventLabels = payload.label;
    this.eventSince = payload.since;
    this.eventUntil = payload.until;
    this.eventSports = payload.sport;
  }

  /* Same logic than this.populateRouteFilters but for providers filters */
  populateProviderFilters (payload: any) {
    this.providerTypes = payload.providerTypes;
    this.providerRespect = payload.providerRespect;
  }

  /*
    This method is called in fetch cycle in SSR mode. The objective of this
    method is to prefill page datas if the route contains queries that allow it.
    Every logic here is based on route URL when user arrives on the page.
  */
  prefillQueries () {
    const routeTypesInStore: string[] = [];
    const routeDifficultiesInStore: number[] = [];
    let routeElevationMinInStore: number = 0;
    let routeElevationMaxInStore: number = 0;
    let routeDistancesMinInStore: number = 0;
    let routeDistancesMaxInStore: number = 0;
    let routeIsOpened: boolean = false;
    let routeCity: any = '';

    if (this.$route.query['types[]']) {
      const query: any = this.$route.query['types[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) routeTypesInStore.push(query);
      else {
        // eslint-disable-next-line array-callback-return
        query.map((t: string) => {
          routeTypesInStore.push(t);
        });
      }
    }

    if (this.$route.query?.opened && this.$route.query?.opened === 'true') {
      routeIsOpened = true;
    }

    if (this.$route.query['difficulties[]']) {
      const query: any = this.$route.query['difficulties[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) routeDifficultiesInStore.push(Number(query));
      else {
        // eslint-disable-next-line array-callback-return
        query.map((t: string) => {
          routeDifficultiesInStore.push(Number(t));
        });
      }
    }

    if (this.$route.query?.elevation_min) routeElevationMinInStore = Number(this.$route.query.elevation_min);
    if (this.$route.query?.elevation_max) routeElevationMaxInStore = Number(this.$route.query.elevation_max);
    if (this.$route.query?.distance_min) routeDistancesMinInStore = Number(this.$route.query.distance_min);
    if (this.$route.query?.distance_max) routeDistancesMaxInStore = Number(this.$route.query.distance_max);
    if (this.$route.query?.routeCity) {
      routeCity = this.$route.query.routeCity;
      this.cityFiltered = routeCity;
    }

    const eventTypes: string[] = [];
    let eventSince: any = '';
    let eventUntil: any = '';

    if (this.$route.query['event_type[]']) {
      const query: any = this.$route.query['event_type[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) eventTypes.push(query);
      else {
        // eslint-disable-next-line array-callback-return
        query.map((t: string) => {
          eventTypes.push(t);
        });
      }
    }

    if (!this.$route.query.since && !this.$route.query.until) {
      eventSince = this.$dayjs().format('YYYY-MM-DD');
    }

    if (this.$route.query.since) eventSince = this.$route.query.since;
    if (this.$route.query.until) eventUntil = this.$route.query.until;

    const providerTypes: string[] = [];
    let providerRespect: boolean = false;

    if (this.$route.query['providerTypes[]']) {
      const query: any = this.$route.query['providerTypes[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) providerTypes.push(query);
      else {
        // eslint-disable-next-line array-callback-return
        query.map((q: string) => {
          providerTypes.push(q);
        });
      }
    }

    if (this.$route.query.providerRespect) providerRespect = true;

    this.routeDifficulties = routeDifficultiesInStore;
    this.routeOpened = routeIsOpened;
    this.routeTypes = routeTypesInStore;
    this.routeElevationMin = routeElevationMinInStore;
    this.routeElevationMax = routeElevationMaxInStore;
    this.routeDistanceMin = routeDistancesMinInStore;
    this.routeDistanceMax = routeDistancesMaxInStore;

    if (this.$route.query['sport'] || this.$route.query['sport[]']) {
      const query: any = this.$route.query['sport'] || this.$route.query['sport[]'];
      this.routeSports = typeof query === 'string' ? [query] : query;
      this.eventSports = typeof query === 'string' ? [query] : query;
    }

    if (this.$route.query['label[]']) {
      const query: any = this.$route.query['label[]'];
      const labels = typeof query === 'string' ? [Number(query)] : query.map((labelId: string) => Number(labelId));

      this.routeLabels = labels;
      this.eventLabels = labels;
    }

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {
      sport: this.routeSports,
      types: routeTypesInStore,
      opened: routeIsOpened,
      difficulties: routeDifficultiesInStore,
      elevation_min: routeElevationMinInStore,
      elevation_max: routeElevationMaxInStore,
      distance_min: routeDistancesMinInStore,
      distance_max: routeDistancesMaxInStore,
      label:  this.routeLabels,
      routeCity,
    });

    this.eventTypes = eventTypes;
    this.eventSince = eventSince;
    this.eventUntil = eventUntil;

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {
      sport: this.eventSports,
      event_type: eventTypes,
      since: eventSince,
      until: eventUntil,
      label:  this.eventLabels,
    });

    this.providerTypes = providerTypes;
    this.providerRespect = providerRespect;

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_PROVIDERS_FILTERS', {
      providerTypes,
      providerRespect,
    });
  }
}
